import { IEntity } from '@pf/shared-common';
import {
    EquipmentFragment,
    PutAwayListSearchRequestParams,
    PutAwayListViewModelCreateBody,
    PutAwayListViewModelRead,
    PutAwayViewModelRead,
    ResourceAuth,
    WarehouseFragment,
} from '@control-tower/platform-wms';
import { IWarehouseEntity } from '../interfaces/warehouse-entity';
import { PutAwayDto } from './put-away.dto';
import { mapToClassSafe } from '@pf/shared-utility';
import { IUserFragment } from '@pf/shared/util-platform';

export type PutAwayListRead = PutAwayListViewModelRead &
    IEntity & { putAways: PutAwayViewModelRead[] };
export type PutAwayListCreate = PutAwayListViewModelCreateBody;
export type PutAwayListSearchParams = PutAwayListSearchRequestParams;

export type PutAwayLineRead = PutAwayViewModelRead & IEntity;

export class PutAwayListDto implements IWarehouseEntity {
    constructor(data: Partial<PutAwayListDto>) {
        Object.assign(this, data);
        this.putAways = mapToClassSafe(data.putAways, PutAwayDto);
        this.putAways?.forEach((putAway: PutAwayDto) => {
            putAway.putAwayListId = this.id;
        });
    }

    id!: string;
    warehouse!: WarehouseFragment;
    warehouseId?: string;

    assignedToUser?: IUserFragment | null;
    putAwayByDate?: string;
    organizedByUser?: IUserFragment | null;
    status?: string | null;
    putAways?: PutAwayDto[];

    get name(): string {
        return `${this.equipment?.name ?? 'Put Away'} - ${this.status}`;
    }

    resourceAuth?: ResourceAuth;
    createdDate?: string;
    modifiedDate?: string;
    isDeleted?: boolean;

    equipmentId?: string;
    equipment?: EquipmentFragment;
}
